"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'layoutTagsViewContextmenu',
  props: {
    dropdown: {
      type: Object
    }
  },
  data: function data() {
    return {
      isShow: false,
      dropdownList: [{
        id: 0,
        txt: '刷新',
        affix: false,
        icon: 'el-icon-refresh-right'
      }, {
        id: 1,
        txt: '关闭',
        affix: false,
        icon: 'el-icon-close'
      }, {
        id: 2,
        txt: '关闭其他',
        affix: false,
        icon: 'el-icon-circle-close'
      }, {
        id: 3,
        txt: '关闭全部',
        affix: false,
        icon: 'el-icon-folder-delete'
      }],
      path: {},
      arrowLeft: 5
    };
  },
  computed: {
    dropdowns: function dropdowns() {
      // 99 为 `Dropdown 下拉菜单` 的宽度
      if (this.dropdown.x + 99 > document.documentElement.clientWidth) {
        return {
          x: document.documentElement.clientWidth - 99 - 5,
          y: this.dropdown.y
        };
      } else {
        return this.dropdown;
      }
    },
    // 监听路由个数
    tagsViewList: function tagsViewList() {
      return this.$store.state.menu.tagNavList || [];
    },
    // 根据路由个数动态控制菜单项
    dynamicDropdownList: function dynamicDropdownList() {
      var routeCount = this.tagsViewList.length;
      var list = _toConsumableArray(this.dropdownList);

      // 如果只有一个路由，禁用"关闭其他"和"关闭全部"
      if (routeCount <= 1) {
        list = list.map(function (item) {
          if (item.id === 2 || item.id === 3) {
            return _objectSpread(_objectSpread({}, item), {}, {
              disabled: true
            });
          }
          return item;
        });
      }
      return list;
    }
  },
  mounted: function mounted() {
    // 监听页面监听进行右键菜单的关闭
    document.body.addEventListener('click', this.closeContextmenu, {
      passive: true
    });
  },
  methods: {
    // 当前项菜单点击
    onCurrentContextmenuClick: function onCurrentContextmenuClick(id) {
      this.$emit('currentContextmenuClick', {
        id: id,
        path: this.path
      });
    },
    // 打开右键菜单：判断是否固定，固定则不显示关闭按钮
    openContextmenu: function openContextmenu(item) {
      var _this = this;
      this.path = item.path;
      item.meta.isAffix ? this.dropdownList[1].affix = true : this.dropdownList[1].affix = false;
      this.closeContextmenu();
      setTimeout(function () {
        _this.isShow = true;
      }, 80);
    },
    // 关闭右键菜单
    closeContextmenu: function closeContextmenu() {
      this.isShow = false;
    }
  },
  destroyed: function destroyed() {
    // 页面卸载时，移除右键菜单监听事件
    document.body.removeEventListener('click', this.closeContextmenu);
  },
  // 监听下拉菜单位置
  watch: {
    dropdown: {
      handler: function handler(_ref) {
        var x = _ref.x;
        if (x + 99 > document.documentElement.clientWidth) this.arrowLeft = 99 - (document.documentElement.clientWidth - x);else this.arrowLeft = 10;
      },
      deep: true
    }
  }
};